export default {
  appName: "Fabulous Branding Agency",
  domain:  process.env.NODE_ENV == 'production' ? 'https://www.fabulousbrandingagency.com':'http://127.0.0.1:8000',
  localUserKey: "fabulousUserkey"
}
